import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo/kakao.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-full object-cover"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import { onMounted, ref } from 'vue';
declare global {
  interface Window {
    Kakao: any;
  }
}

export default /*#__PURE__*/_defineComponent({
  __name: 'KakaoShare',
  props: {
  title : {type : String, required : true},
  date : {type : String, required : true},
  loca : {type : String, required : true},
  img : {type : String, required : true},
  link : {type : String, required : true},
},
  setup(__props) {

const kakaoApi = process.env.VUE_APP_KAKAO_API
const templateId = process.env.VUE_APP_KAKAO_SHARE_ID
const props = __props;
const desc = ref(`${props.date} \n${props.loca}`);


const loadKakaoSDK = () => {
  return new Promise<void>((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.7.0/kakao.min.js';
    script.integrity = 'sha384-l+xbElFSnPZ2rOaPrU//2FF5B4LB8FiX5q4fXYTlfcG4PGpMkE1vcL7kNXI6Cci0';
    script.crossOrigin = 'anonymous';
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
};
const title = ref(props.title)
const shareMessage = () => {
    window.Kakao.Share.sendCustom({
        // objectType: 'feed',
        templateId: 105773,
        templateArgs: {
            THU: props.img,
            PATH : props.link,
            DESC : desc.value,
            TITLE : props.title,

        },
    // content: {
    //   title: '딸기 치즈 케익',
    //   description: '#케익 #딸기 #삼평동 #카페 #분위기 #소개팅',
    //   imageUrl:
    //     'http://k.kakaocdn.net/dn/Q2iNx/btqgeRgV54P/VLdBs9cvyn8BJXB3o7N8UK/kakaolink40_original.png',
    //   link: {
    //     mobileWebUrl: 'https://padaapp.com',
    //     webUrl:'https://padaapp.com',
    //   },
    // },
    // buttons: [
    //   {
    //     title: '웹으로 보기',
    //     link: {
    //       mobileWebUrl:'https://padaapp.com/news/event/59',
    //       webUrl: 'https://padaapp.com/news/event/59',
    //     },
    //   },

    // ],
  });

};
const initKakao = () => {
  if (!window.Kakao.isInitialized()) {
    window.Kakao.init(kakaoApi);
  }
};


onMounted(async () => {
  await loadKakaoSDK();
  initKakao();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    id: "kakaotalk-link-btn",
    onClick: shareMessage
  }, _hoisted_2))
}
}

})